<form class="c-form" #mainForm="ngForm">
	<div *ngIf="vm.initialized" class="o-grid o-grid--wrap">
		<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up u-no-p">
			<div class="o-grid o-grid--column">
				<div class="o-grid__cell u-osb-md u-hidden@md-and-up" *ngIf="vm.service?.subcategory === 'GENERAL_MEDICAL_PRACTICE'">
					<item-notification icon="attention" [text]="'Booking.Instant.Disclaimer_Covid' | translate" [theme]="5"></item-notification>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<section class="c-section c-section--first" panel [isOpen]="vm.isOpen?.service">
						<div class="c-section__header">
							<h1 class="c-section__title c-section__title--sm">{{ 'Booking.Title.Service' | translate }}</h1>
						</div>
						<div class="c-section__content">
							<div class="o-grid">
								<div class="o-grid__cell c-cell u-no-m">
									<card-service [service]="vm.service" [isMinimal]="true" *ngIf="vm.service"></card-service>
								</div>
							</div>
						</div>
					</section>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<section class="c-section u-no-p" panel [isOpen]="vm.isOpen?.description" [ngClass]="{ 'c-section--error': (vm.submitted || description.dirty) && description.invalid }">
						<div class="c-section__header">
							<h2 class="c-section__title c-section__title--sm c-section__title--offset">{{ 'Booking.Problem_Description_Short' | translate }} *</h2>
						</div>
						<div class="c-section__content">
							<div class="o-grid">
								<div class="o-grid__cell c-cell u-no-m">
									<div class="c-card" [ngClass]="{ 'c-card--error': (vm.submitted || description.dirty || description.touched) && description.invalid }">
										<div class="c-content u-no-p@up-to-md">
											<div class="c-form__group u-no-m">
												<label for="description" class="u-sr-only">{{ 'Booking.Problem_Description_Short' | translate }}</label>
												<textarea name="description" id="description" #description="ngModel" rows="6" class="c-form__input c-form__input--no-border u-no-p@md-and-up" placeholder="{{ vm.getPlatformProblemPlaceholderTranslation() }}" [(ngModel)]="vm.booking.comment" required maxlength="{{vm.descMaxLength}}" [disabled]="vm.isProcessing"></textarea>
											</div>
											<p class="c-text c-text--sm c-text--gray c-text--right u-osb-sm@up-to-md u-osr-sm@up-to-md" [ngClass]="{ 'c-text--s3': (vm.submitted || description.dirty) && description?.errors?.maxlength }">{{ description?.value?.length || 0 }} / {{ vm.descMaxLength }}</p>
										</div>
										<loader-overlay *ngIf="vm.isProcessing || !vm.isBookingInitialized"></loader-overlay>
									</div>
								</div>
							</div>
						</div>
					</section>
				</div>
				<div class="o-grid__cell u-ost-md u-hidden@up-to-md" *ngIf="vm.service?.subcategory === 'GENERAL_MEDICAL_PRACTICE'">
					<item-notification icon="attention" [text]="'Booking.Instant.Disclaimer_Covid' | translate" [theme]="5"></item-notification>
				</div>
			</div>
		</div>
		<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-67@md-and-up u-no-p">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p">
					<section class="c-section c-section--last" panel [isOpen]="vm.isOpen?.time" [ngClass]="{ 'c-section--error': vm.submitted && (vm.isForCareTaken && (careTakenName?.invalid || careTakenIdCode?.invalid)) }">
						<div class="c-section__header">
							<h2 class="c-section__title c-section__title--sm">{{ 'Booking.Overview' | translate }}</h2>
						</div>
						<div class="c-section__content">
							<div class="o-grid">
								<div class="o-grid__cell u-no-p@up-to-md">
									<div class="c-card">
										<div class="c-content">
											<div class="o-grid o-grid--wrap">
												<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
													<div class="o-grid">
														<div class="o-grid__cell u-no-pl">
															<p class="c-text c-text--gray u-no-wrap">{{ 'Booking.Service' | translate }}</p>
														</div>
														<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
															<p class="c-text c-text--right c-text--s2" *ngIf="vm.isHomeVisit">{{ 'Booking.Home_Visit' | translate }}</p>
															<p class="c-text c-text--right c-text--s2" *ngIf="vm.isPrescription">{{ 'Booking.Prescription.Prescription' | translate }}</p>
															<p class="c-text c-text--right c-text--s2" *ngIf="!vm.isHomeVisit && !vm.isPrescription && vm.booking.communicationType">{{ 'Booking.CommunicationType.' + vm.booking.communicationType | translate }}</p>
														</div>
													</div>
													<div class="o-grid">
														<div class="o-grid__cell u-no-pl">
															<p class="c-text c-text--gray u-no-wrap">{{ 'Booking.Date' | translate }}</p>
														</div>
														<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
															<p class="c-text c-text--right c-text--s2">{{ vm.booking.date }}</p>
														</div>
													</div>
													<div class="o-grid" *ngIf="vm.booking.start && vm.booking.end">
														<div class="o-grid__cell u-no-pl">
															<p class="c-text c-text--gray u-no-wrap">{{ 'Booking.Time' | translate }}</p>
														</div>
														<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
															<p class="c-text c-text--right c-text--s2">{{ vm.booking.start }} - {{ vm.booking.end }} ({{ vm.booking.duration }} {{ 'Units.Minutes' | translate | lowerCase }})</p>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<loader-overlay [theme]="1" *ngIf="vm.isProcessing || vm.addingFundsInProgress"></loader-overlay>
						</div>

						<div class="c-content u-no-p@md-and-up" *ngIf="vm.user?.origin == 'minudoc.ee'">
							<div class="o-grid o-grid--wrap u-ost-md@md-and-up">
								<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up o-grid__cell--flex u-no-p@up-to-md o-grid__cell--center" >
									<div class="c-form__group u-osb-md@md-and-up" [ngClass]="{'u-ost-md@md-and-up': vm.isForCareTaken }">
										<label class="c-checkbox">
											<input id="careTakenCheckbox" name="careTakenCheckbox" type="checkbox" #isForCareTaken="ngModel" [(ngModel)]="vm.isForCareTaken" [disabled]="vm.isProcessing">
											<span id="isForCareTakenLabel">{{ 'Booking.Form.Label.Booking_For_Care_Taken' | translate }}<item-info-popover [text]="'Booking.Form.Info_Care_Taken' | translate" placement="right" placementMobile="top" [wrapperMobile]="vm.popoverMobileWrapper" (click)="$event.preventDefault()" style="vertical-align:middle" class="u-osl-xs"></item-info-popover></span>
										</label>
									</div>
								</div>
								<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up o-grid__cell--o1@md-and-up u-no-p@up-to-md" *ngIf="vm.isForCareTaken"></div>
								<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up o-grid__cell--bottom u-no-p@up-to-md" *ngIf="vm.isForCareTaken">
									<div class="c-form__group" [ngClass]="{'c-form__group--error': vm.submitted && careTakenName?.invalid}">
										<label for="name" class="c-form__label c-form__label--required">{{ 'Booking.Form.Label.Care_Taken_Name' | translate }}</label>
										<input type="text" name="name" id="name" #careTakenName="ngModel" class="c-form__input" [(ngModel)]="vm.booking.careTakenInfo.name" required maxlength="255" [disabled]="vm.isProcessing" />
									</div>
								</div>
								<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up o-grid__cell--bottom u-no-p@up-to-md" *ngIf="vm.isForCareTaken">
									<div class="c-form__group" [ngClass]="{'c-form__group--error': vm.submitted && careTakenIdCode?.invalid}">
										<label for="idcode" class="c-form__label c-form__label--required">{{ 'Booking.Form.Label.Care_Taken_Personal_Code' | translate }}</label>
										<input type="text" name="idcode" id="idcode" #careTakenIdCode="ngModel" class="c-form__input" [(ngModel)]="vm.booking.careTakenInfo.personalCode" required maxlength="11" minlength="11" [disabled]="vm.isProcessing" />
									</div>
								</div>
							</div>
						</div>

					</section>
				</div>
			</div>
			<div class="o-grid u-ost-md@up-to-md" [ngClass]="{'u-ost-md': vm.user?.origin == 'siffi.com'}">
				<div class="o-grid__cell u-hidden@up-to-md"></div>
				<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right">
					<button id="reservationSubmitButton" type="button" class="c-button c-button--s2 c-button--fit c-button--lg" (click)="vm.handleFormSubmit(mainForm)" >{{ 'Booking.Button.Pay' | translate }}</button>
				</div>
			</div>
		</div>
	</div>
</form>